import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { sidebarActions } from 'redux/app/sidebar/sidebar.slice';

export const useAppBar = () => {
  const dispatch = useDispatch();
  const toggleSidebar = useCallback(
    () => dispatch(sidebarActions.toggle()),
    [dispatch],
  );

  return { toggleSidebar };
};
